import React from 'react'

interface SurveyContextType {
  disabledFields: string[]
}

const SurveyContext = React.createContext<SurveyContextType>({
  disabledFields: []
})

export function useSurveyContext (): SurveyContextType {
  const value = React.useContext(SurveyContext)
  if (value == null) {
    throw new Error('useSurveyContext must be wrapped in a <SurveyContextProvider />')
  }
  return value
}

export function SurveyContextProvider (
  props: React.PropsWithChildren<SurveyContextType>
): React.ReactNode {
  return (
    <SurveyContext.Provider
      value={{
        ...props
      }}
    >
      {props.children}
    </SurveyContext.Provider>
  )
}
